/* eslint-disable eqeqeq */
import { ajaxNew as ajax } from '../../../../../scanline/utils/ajax';
import { hasAccessToken } from '../../../../../scanline/utils/token';

/** ************************
 * HELPERS
 */

const encodeData = data => {
	if (!data) {
		return data;
	}

	if (data instanceof Object) {
		return JSON.stringify(data);
	}

	return data;
};

export const createPromiseRequest = ({
	url,
	data: paramData,
	method = 'GET',
	aip = 'scanlineaggregates',
	isAnonymous
}) => () => {
	const data = encodeData(paramData);
	return new Promise((resolve, reject) => {
		ajax({
			url,
			data,
			method,
			callback: (err, res) => {
				if (err) {
					reject(err);
				} else {
					resolve(res);
				}
			},
			isAnonymous,
			aip
		});
	});
};

const _formatLinesAggs = (linesAggs, { customer, jobNumber }) => {
	const _linesAggs = linesAggs.filter(la => la.customerName === customer);
	const result = _linesAggs.map(la => {
		return {
			...la,
			jobs: la.jobs.filter(j => j.job == jobNumber) || [],
			relatedJobs: la.jobs.filter(j => j.job != jobNumber) || []
		};
	});

	return result;
};

/** ************************
 * API
 */

export const fetchLinesAggs = async ({
	customer,
	jobNumber,
	lineName
} = {}) => {
	const url = '/lines';

	if (hasAccessToken()) {
		const fetchData = createPromiseRequest({
			url,
			method: 'POST',
			data: { lineNames: [lineName], returnType: 'list' }
		});

		return fetchData().then((linesAggs = []) => {
			return _formatLinesAggs(linesAggs, { customer, jobNumber });
		});
	}
	return Promise.reject(new Error('Missing Token'));
};

export const fetchLineHistorySummaries = async ({ lineId, lineGuid } = {}) => {
	const url = '/line/app-state-and-report-history-summaries';

	if (hasAccessToken()) {
		const fetchData = createPromiseRequest({
			aip: 'scanline',
			url,
			method: 'POST',
			data: { lineId, lineGuid }
		});

		return fetchData().then((historySummaries = {}) => {
			return historySummaries;
		});
	}
	return Promise.reject(new Error('Missing Token'));
};
